import { useRoutes } from 'react-router-dom';
import { UserAccountView } from '../components/';

export default function UserRouter() {
  const element = useRoutes([{ path: '', element: <UserAccountView /> }]);
  return element;
}
